import styled from 'styled-components';

export const PageHeader = styled.h2`
    padding-top: 1em;
    margin-bottom: 1em;
`;
